module.exports = __webpack_public_path__ + "images/0fc941f9.exclusive_3_chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/exclusive/exclusive_3_chs.png
// module id = 453
// module chunks = 0